class BuildsTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Wait for the DOM to be fully loaded
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.initTabs());
    } else {
      this.initTabs();
    }
  }

  initTabs() {
    // Get all tab buttons and content sections, scoped to this component
    const tabButtons = this.querySelectorAll(".builds__tab-button");
    const tabContents = this.querySelectorAll(".builds__tab-content");

    // Add click event listeners to tab buttons
    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.getAttribute("data-tab");

        // Remove active class from all buttons and contents
        tabButtons.forEach((btn) =>
          btn.classList.remove("builds__tab-button--active")
        );
        tabContents.forEach((content) =>
          content.classList.remove("builds__tab-content--active")
        );

        // Add active class to clicked button and corresponding content
        button.classList.add("builds__tab-button--active");
        this.querySelector(
          `.builds__tab-content[data-content="${tabId}"]`
        ).classList.add("builds__tab-content--active");
      });
    });
  }
}

// Define the custom element
if (!customElements.get("builds-tabs")) {
  customElements.define("builds-tabs", BuildsTabs);
}
